import React, { FC } from 'react';

export const Card: FC = ({ children }) => {
  return (
    <>
      <div className="card">{children}</div>
      <style jsx>{`
        .card {
          align-items: center;
          display: flex;
          justify-content: center;
          box-sizing: border-box;
          overflow: hidden;
          text-align: center;
          user-select: none;
          flex-direction: column;
          min-width: 50%;
          text-overflow: ellipsis;
          min-height: 440px;
        }

        @media (min-width: 1024px) {
          .card {
            min-width: 25%;
          }
        }

        :global(.card *) {
          text-overflow: ellipsis;
          overflow: hidden;
        }
      `}</style>
    </>
  );
};
